/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import ManageControls from 'src/components/manage-controls.jsx';
import Button from '#lib/components/button.jsx';
import { validateUser } from '#lib/helpers/errors.js';
import { toast } from 'react-hot-toast';
import { Icon } from '@iconify-icon/react';
import { addClasses, cn } from '#lib/helpers/class.js';

export function UserButtons(props) {
    const { disabled, users, selectedUser, isLoading, handleSaveUser, handleDeleteUser, setErrors } = props;

    return (
        <ManageControls.ButtonSlot>
            <Button
                className={addClasses(cn(disabled && '!opacity-0'))}
                title={_t.global.save()}
                onClick={() => {
                    if (!validateUser(selectedUser, users, setErrors)) return toast.error(_t.global.validationError());
                    if (selectedUser?.loading) {
                        toast.error(_t.crud.itinerary.waitMediaLoaded());
                        return;
                    }
                    handleSaveUser(selectedUser);
                }}
                size="xs"
                busy={isLoading}
                disabled={disabled}
            >
                <span className={'w-full flex justify-center'}>
                    <Icon
                        icon="material-symbols:save-outline-rounded"
                        width="1.2rem"
                        height="1.2rem"
                        className="mr-1"
                    />
                    {_t.global.save()}
                </span>
            </Button>
            <Button
                className={addClasses(cn(disabled && '!opacity-0'))}
                title={_t.global.delete()}
                onClick={() => {
                    if (selectedUser?.loading) {
                        toast.error(_t.crud.itinerary.waitMediaLoaded());
                        return;
                    }
                    const confirm = window.confirm(_t.global.confirmDelete());
                    if (!confirm) return;
                    handleDeleteUser(selectedUser);
                }}
                size="xs"
                disabled={disabled}
            >
                <span className="w-full flex justify-center text-red-700">
                    <Icon icon="ph:trash" width="1.2rem" height="1.2rem" className="mr-1" />
                    {_t.global.delete()}
                </span>
            </Button>
        </ManageControls.ButtonSlot>
    );
}
